export default "__VITE_ASSET__B9YVK4GB__"